import backrsBannerLogo from '@backrs_ui/grow-ui/src/assets/images/backrs-banner-logo.png';

import { Box, SxProps, Theme } from '@mui/material';

/** Backrs logo pinned to a banner's top-left corner. Sized off the nearest `inline-size` container. */
export const BackrsBannerLogo = () => (
  <Box component="img" src={backrsBannerLogo} alt="Backrs" sx={logoSx} />
);

const logoSx: SxProps<Theme> = ({ backrs }) => ({
  position: 'absolute',
  top: backrs.spacing['spacing-lg'],
  left: backrs.spacing['spacing-lg'],
  width: 'clamp(96px, 14cqw, 160px)',
  height: 'auto',
  pointerEvents: 'none',
  '@container (max-width: 599px)': {
    top: backrs.spacing['spacing-sm'],
    left: backrs.spacing['spacing-sm'],
    width: 'clamp(48px, 14cqw, 96px)',
  },
});
